import React from "react";
import CalendarInvitation from "./CalendarInvitation";
import { templateHelper } from "../../../template/helpers/templateHelper";

export const calendarInvitationHandler = {
  tags,
  elementEditor,
  defaultStyle,
  component,
  families,
};

function component(element) {
  return <CalendarInvitation element={element} />;
}

function tags() {
  return {
    startTag: "<!-- 1 Column Text : BEGIN -->",
    endTag: "<!-- 1 Column Text : END -->",
  };
}

function families() {
  return ["image", "text"];
}

function defaultStyle(templateStyle = null, defaultStyle = true, inherited = []) {
  const templateTextStyle = templateStyle ? templateStyle.text : null;
  const inheritedStyles =
    templateStyle && !defaultStyle
      ? [
          { templatePath: "text.color", stylePath: "textStyle.color" },
          { templatePath: "text.fontSize", stylePath: "textStyle.fontSize" },
        ]
      : [];
  return {
    wrapper: {
      backgroundColor: "#ffff",
    },
    elementProps: {
      source: "https://via.placeholder.com/680x180",
      editor: null,
      width: "600",
      height: "auto",
      altText: "alt_text",
      border: "0",
      link: "",
      text: "Add invitation from sidebarlist",
      invitationId: null,
    },
    styleProps: {
      width: "100%",
      maxWidth: "680px",
      padding: "20px",
    },
    textStyle: {
      padding: "20px",
      fontFamily: "sans-serif",
      fontSize: templateTextStyle && !defaultStyle ? templateTextStyle.fontSize : "15px",
      lineHeight: "normal",
      color: templateTextStyle && !defaultStyle ? templateTextStyle.color : "#555555",
    },
    className: "g-img",
    inheritedStyles: inheritedStyles,
  };
}
function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
  //Take what is relevant from the template
  const templateContentStyle = templateStyle ? templateStyle.content : null;
  const templateTextStyle = templateStyle ? templateStyle.text : null;
  return `<tr>
  <td style="background-color: #fff;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
     <tr>
              <td 
              class="styleWrapper"
                  style="padding: ${elementStyle.styleProps.padding}; 
                  font-family: ${elementStyle.styleProps.fontFamily}; 
                  font-size: ${templateTextStyle && !defaultStyle ? templateTextStyle.fontSize : elementStyle.styleProps.fontSize}; 
                  line-height: normal; 
                  color: ${templateTextStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateTextStyle.color) : templateHelper.convertRgbStringToHex(elementStyle.textStyle.color)};">

  [TemplateStyle]
  <a href="${elementStyle.elementProps.link}" download="${elementStyle.elementProps.text}"> ${elementStyle.elementProps.text}</a>
                  </td>
              </tr>
   
      </table>
  </td>
</tr>`;
}
